import React from 'react'
import { Layer, Image as ImageKonva, Line, Group } from 'react-konva'

import { Line as LineInterface } from '../../../reducers/editPhoto'
import { SquareLine, TriangleLine } from '../shapes'

interface EraserOverlayLayerProps {
    beforeImageRef: HTMLImageElement
    lines: LineInterface[]
    width: number
    height: number
}

/**
 * 消しゴムオーバーレイレイヤー
 * Before画像を線の部分だけ表示する（線の部分でBefore画像をクリップ）
 * previewCanvasはAfter画像を表示し、このオーバーレイで線の部分だけBefore画像を上に重ねる
 */
export const EraserOverlayLayer: React.FC<EraserOverlayLayerProps> = ({
    beforeImageRef,
    lines,
    width,
    height,
}) => {
    return (
        <Layer>
            {/* 線を描画（マスクとして使用） */}
            {lines.map((line: LineInterface, i: number) => {
                if (line.head === 'circle')
                    return (
                        <Line
                            key={i}
                            points={line.points}
                            stroke="white"
                            strokeWidth={line.headSize}
                            tension={0.3}
                            opacity={1}
                            lineCap="round"
                            lineJoin="round"
                        />
                    )
                if (line.head === 'square') return <SquareLine key={i} line={line} stroke="white" fill="white" />
                if (line.head === 'triangle') return <TriangleLine key={i} line={line} stroke="white" fill="white" />
                return null
            })}

            {/* source-inでBefore画像を線の部分だけ表示 */}
            <Group globalCompositeOperation="source-in">
                <ImageKonva image={beforeImageRef} width={width} height={height} />
            </Group>
        </Layer>
    )
}
